import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { FormBuilder } from "@angular/forms";

import { Establishment } from '../../../models/Establishment';
import { AuthService } from '../../../services/auth.service';
import { customColumnsAgencyUsers } from '../../../pages/etablissement/mon-etablissement/components/sites-adresses/data/datable.data';
import { AddUserComponent } from './add-user/add-user.component';
import { DetailsUserComponent } from './details-user/details-user.component';
import { EstablishmentService } from '../../../services/establishment.service';

@Component({
  selector: 'app-agency-users',
  templateUrl: './agency-users.component.html',
  styleUrl: './agency-users.component.scss'
})
export class AgencyUsersComponent implements OnInit {

  @Input() establishment: Establishment;
  protected readonly customColumnsAgencyUsers = customColumnsAgencyUsers;

  offset = 0;
  limit = 10;
  loading = false;
  form = this.fb.group({
    agencyId: this.auth.id,
    keyword: [''],
    offset: this.offset,
    limit: this.limit,
  })
  personsList: any[] = []
  personsListFiltered: any[] = []
  totalItems: number
  agenciesMap: Map<string, string> = new Map();

  constructor(private dialog: MatDialog,
    private establishmentService: EstablishmentService,
    private fb: FormBuilder,
    private auth: AuthService,
  ) {
  }

  ngOnInit() {
    this.fetchAgenciesAndUsers();
    this.establishmentService.getRefreshObservable().subscribe(() => {
        this.fetchAgenciesAndUsers();
      });
  }

  openAddUtilisateurDialog() {
    const dialogRef = this.dialog.open(AddUserComponent, {
      width: '700px',
      autoFocus: false,

    })
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.fetchAgenciesAndUsers()
      }
    })
  }

  pagination(event: any) {
    this.form.get('offset')?.patchValue(event.pageIndex)
    this.fetchAgenciesAndUsers();
  }

  handleRowClick = (row: any) => {
    this.dialog.open(DetailsUserComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
  };

  searchUser(event: any) {
    const keyword = event.target.value.trim().toLowerCase();
    console.log('keyword', keyword);
    if (keyword) {
      this.personsListFiltered = this.personsList.filter((person: any) => {
        return (
          person.mail?.toLowerCase().includes(keyword)
        );
      });
    } else {
      this.personsListFiltered = [...this.personsList];
    }
  }

  fetchAgenciesAndUsers() {
    this.loading = true;

    // Fetch agencies first
    this.establishmentService.getAgencies().subscribe({
      next: (agencies: any[]) => {
        // Create a map of agency ID to agency name
        this.agenciesMap = new Map(agencies.map((agency) => [agency.dirigeant_principal?.email, agency.name]));

        // Fetch users after fetching agencies
        this.consumeGetAgenciesUsers();
      },
      error: (err) => {
        console.error('Failed to fetch agencies', err);
        this.loading = false;
      },
    });
  }

  consumeGetAgenciesUsers() {
    this.establishmentService.getAgenciesUsers().subscribe({
      next: (users: any[]) => {
        if (!!users && users.length > 0) {
          this.personsList = users.map((user: any) => {
            return {
              id: user.id,
              mail: user?.email,
              title: user?.title,
              firstName: user?.firstName.split(' ')[0],
              lastName: user?.firstName.split(' ')[1],
              fonction: user?.lastName,
              numTel: user?.phoneNumber,
            };
          });
          this.personsListFiltered = [...this.personsList];
          this.totalItems = users.length;
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Failed to fetch users', err);
        this.loading = false;
      },
    });
  }
}
